export default __webpack_public_path__ + "static/media/Sume_JessicaDiaz.3653308f.png";